// extracted by mini-css-extract-plugin
module.exports = {"background":"Loader-module--background--37EGS","logo":"Loader-module--logo--tB8Qd"};